var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#637381",
    rx: 6.957
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.823 27.826h.004v-5.741c0-2.808-.605-4.972-3.888-4.972-1.578 0-2.637.867-3.07 1.688h-.045v-1.425H17.71v10.45h3.241V22.65c0-1.362.258-2.68 1.946-2.68 1.662 0 1.687 1.555 1.687 2.767v5.088zM12.432 17.377h3.245v10.45h-3.245zM14.053 12.174a1.88 1.88 0 0 0-1.88 1.88c0 1.037.843 1.897 1.88 1.897 1.038 0 1.88-.86 1.88-1.898s-.843-1.88-1.88-1.88"
  })));
};
export default SvgLinkedin;